import React from 'react';
import { DashboardModal } from '@uppy/react';

interface UppyDashboardModalGuardProps {
	uppy: any;
	openDashboard: boolean;
	onCloseDashboard: () => void;
}

const UppyDashboardModalGuard: React.FC<UppyDashboardModalGuardProps> = (
	props,
) => {
	const { uppy, openDashboard, onCloseDashboard } = props;
	if (!uppy) return null;

	return (
		<DashboardModal
			uppy={uppy}
			open={openDashboard}
			onRequestClose={onCloseDashboard}
			showProgressDetails={true}
			proudlyDisplayPoweredByUppy={false}
			locale={{
				strings: {
					dropPasteFiles: '%{browseFiles}',
					browseFiles: 'Add Attachments',
				},
			}}
			showNativePhotoCameraButton={true}
			showNativeVideoCameraButton={true}
		/>
	);
};

export default UppyDashboardModalGuard;
